import styled from "styled-components";

const StyledCheckbox = styled.div`
  display: inline-flex;
  align-items: center;
  .MuiTypography-root {
    margin-left: 7px;
  }
  .MuiFormControlLabel-label.Mui-disabled {
    opacity: 0.5;
    color: inherit !important;
  }
  .MuiSvgIcon-root {
    color: var(--checkbox-bg);
    width: 21px;
    height: 21px;
  }
  .MuiCheckbox-root {
    padding: 0;
  }
  .Mui-disabled {
    opacity: 0.65;
    cursor: not-allowed !important;
    pointer-events: auto !important;
  }
  /* label {
    margin: 0;
  } */
`;

const CenteredLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  &.innerSectionLoader {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2;
    > div {
      height: 100% !important;
      > div {
        height: 100% !important;
      }
    }
  }
`;

export { StyledCheckbox, CenteredLoader };
